import { setComponentMapOverrides } from '@jutro/uiconfig';
import ConfirmationPage from './pages/Confirmation/ConfirmationPage';
import MailingAddressPage from './pages/MailingAddress/MailingAddressPage';
import ProfileChangePage from './pages/ProfileChange/ProfileChangePage';
import TypeOfChangesPage from './pages/TypeOfChanges/TypeOfChangesPage';
import PaperlessPreferencePage from './pages/PaperlessPreference/PaperlessPreferencePage';

setComponentMapOverrides(
    {
        ConfirmationPage: { component: 'ConfirmationPage' },
        MailingAddressPage: { component: 'MailingAddressPage' },
        ProfileChangePage: { component: 'ProfileChangePage' },
        TypeOfChangesPage: { component: 'TypeOfChangesPage' },
        PaperlessPreferencePage: { component: 'PaperlessPreferencePage' }
    },
    {
        ConfirmationPage,
        MailingAddressPage,
        ProfileChangePage,
        TypeOfChangesPage,
        PaperlessPreferencePage
    }
);
export { default as messages } from './PolicyChangeCommon.messages';
export { default as wizardConfig } from './config/policy-change-wizard-config.json5';
